export enum DataModelDesignerActionTypes {
    CHANGE_DATAMODELID = '@@dataModelDesigner/CHANGE_DATAMODELID',   
    CHANGE_SEARCH_VALUE = '@@dataModelDesigner/CHANGE_SEARCH_VALUE',
    CHANGE_FIELD = '@@dataModelDesigner/CHANGE_FIELD',
    CHANGE_QUERY_OPTIONS_DATASOURCE='@@dataModelDesigner/CHANGE_QUERY_OPTIONS_DATASOURCE',
    CHANGE_SELECTED_FIELD = '@@dataModelDesigner/CHANGE_SELECTED_FIELD',
    CHANGE_SHAXES = '@@dataModelDesigner/CHANGE_SHAXES',
    CHANGE_COLUMN_ALIAS = '@@dataModelDesigner/CHANGE_COLUMN_ALIAS',
    CHANGE_SHAXES_REMOVE = '@@dataModelDesigner/CHANGE_SHAXES_REMOVE',    
    CHANGE_NEWFIELD = '@@dataModelDesigner/CHANGE_NEWFIELD',
    CHANGE_ADDNEWFIELD = '@@dataModelDesigner/CHANGE_ADDNEWFIELD',
    CHANGE_TABALE_POSITION = '@@dataModelDesigner/CHANGE_TABALE_POSITION',
    CHANGE_EDGES = '@@dataModelDesigner/CHANGE_EDGES',
    CHANGE_RESET_INITIAL_STATE = '@@dataModelDesigner/RESET_INITIAL_STATE',
}
